import { useEffect, useRef, useState } from "react";
import MainContentWrapper from "../../Components/MainContentWrapper";
import { getCrmleads } from "../../apis/BhuMeetTeams/Crm/leads";
import TableView from "../../ReusableComponents/TableView/TableView";
import { Button } from "../../Components/Helper";
import { Button as OGButton } from "@mui/material";
import { CreateLeads } from "./createLeads";
import { useNavigate } from "react-router";
import ExcelUploader from "./excelUploader";
import FileUploader from "../../ReusableComponents/FileUploader";
import DurationFilters from "../../features/Revenue/SubComponents/DurationFilters";
import IssueDashboardFilter from "../Operations/RequestIssue/issueDashboardFilter";
import dateFormat from "dateformat";
import { useSelector } from "react-redux";
import LeadsFilter from "./leadsFilter";

import Filter from "../../assets/filter.svg";
import { ta } from "date-fns/locale";
import DNDUploader from "./dndUploader";

export const AllLeads = () => {
  const ProfilePicRef = useRef(null);
  const navigate = useNavigate();
  const [allLeads, setAllLeads] = useState([]);
  const [selectedLead, setSelectedLead] = useState();
  const [openDNDModel, setDNDModel] = useState(false);
  const [filter, setFilters] = useState(() => {
    const getFilters = localStorage.getItem("CRMLeadsFilter");
    return getFilters
      ? JSON.parse(getFilters)
      : {
          fromDate: null,
          toDate: null,
          pageSize: 15,
          count: 0,
          currentPage: 1,
          interval: "all",
          state: "",
          district: "",
          taluka: "",
          type: "",
          is_dnd: null,
        };
  });
  const [openform, setOpenForms] = useState(false);
  const [openLeadFilter, setOpenLeadFilter] = useState(false);

  const [selectedFile, setSelectedFile] = useState();
  const [openExcelModel, setExcelModel] = useState(false);
  const [refresh, setRefresh] = useState(1);
  const [loading, setloading] = useState(false);

  const [leadTabDisabled, setLeadTabDisabled] = useState(false);
  const [existingTabDisabled, setExistingTabDisabled] = useState(false);
  const [retainTabDisabled, setretainTabDisabled] = useState(false);

  const [openFilter, setOpenFilter] = useState(false);
  const [formattedDate, setFormattedDate] = useState();
  const durationOptions = [
    { id: 6, placeholder: "All", interval: "all" },
    { id: 1, placeholder: "Today", interval: "day" },
    { id: 2, placeholder: "This Week", interval: "week" },
    { id: 3, placeholder: "This Month", interval: "month" },
    { id: 4, placeholder: "This Year", interval: "year" },
    {
      id: 5,
      placeholder: "Custom",
      interval: "custom",
      cb: () => {
        setOpenFilter(true);
      },
    },
  ];

  useEffect(() => {
    getAllLeads();
    localStorage.setItem("CRMLeadsFilter", JSON.stringify(filter));
  }, [
    filter.fromDate,
    filter.toDate,
    filter.currentPage,
    filter.state,
    filter.district,
    filter.taluka,
    filter.type,
    filter.is_dnd,
  ]);

  const getAllLeads = async () => {
    setloading(true);
    console.log(filter);
    const leads = await getCrmleads(filter);
    console.log("LeadsData", leads);
    setloading(false);
    setFilters((prev) => ({ ...prev, count: leads.leadCount }));
    setAllLeads(leads.leads);
    getFormattedFromAndToDate(filter.interval);
  };

  const getFormattedFromAndToDate = (interval) => {
    let formattedDate = "";
    switch (interval) {
      case "day":
        formattedDate = `Date: ${dateFormat(filter.fromDate, "dd/mm/yyyy ")}`;
        break;
      case "week":
        const fromDateMinusOneDay = new Date(filter.fromDate);
        fromDateMinusOneDay.setDate(fromDateMinusOneDay.getDate() - 1);
        formattedDate = `Date: ${dateFormat(fromDateMinusOneDay, "dd/mm/yyyy ")} 
                to ${dateFormat(filter.toDate, "dd/mm/yyyy ")}`;
      case "month":
      case "year":
        formattedDate = `Date: ${dateFormat(filter.fromDate, "dd/mm/yyyy ")} 
                to ${dateFormat(filter.toDate, "dd/mm/yyyy ")}`;
        break;
      case "custom":
        formattedDate = `Date: ${dateFormat(filter.fromDate, "dd/mm/yyyy hh:MM TT ")} 
                to ${dateFormat(filter.toDate, "dd/mm/yyyy hh:MM TT")}`;
        break;
      default:
        formattedDate = "";
    }

    setFormattedDate(formattedDate);
  };

  const handleTabSwitch = async (tabType) => {
    console.log(tabType);
    if (tabType === "lead") {
      setretainTabDisabled(true);
    } else {
      setLeadTabDisabled(true);
    }

    // setCurrentPage(() => 1);
    setFilters((prevFilters) => ({
      ...prevFilters,
      type: tabType,
      currentPage: 1,
    }));
    try {
      // await getCoupons();
      // await getCouponsStats();
    } catch (error) {
      console.error("Error fetching data:", error);
      setLeadTabDisabled(false);
      setretainTabDisabled(false);
    } finally {
      // Re-enable tabs after a delay
      setTimeout(() => {
        setLeadTabDisabled(false);
        setretainTabDisabled(false);
      }, 1200);
    }
  };

  return (
    <MainContentWrapper
      header={"Leads" + ` (${filter.count})`}
      rightContent={
        <>
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              style={{ whiteSpace: "nowrap", height: "30px" }}
              text="Create Lead"
              onClick={() => setOpenForms(true)}
              className="btn-large"
            />
            <Button
              style={{ whiteSpace: "nowrap", height: "30px" }}
              text="Import"
              onClick={() => setExcelModel(true)}
              className="btn-large"
            />
            {/* <Button
              style={{ whiteSpace: "nowrap", width: "150px", height: "30px" }}
              text="Import DND Report "
              onClick={() => setDNDModel(true)}
              className="btn-large"
            /> */}
            <div style={{ height: "29px" }}></div>
          </div>

          {openExcelModel && (
            <ExcelUploader
              open={openExcelModel}
              e={selectedFile}
              close={(e) => {
                setExcelModel(false);
                setSelectedFile(null);
                setRefresh(refresh + 1);
                getAllLeads();
              }}
            />
          )}
          {/* {openDNDModel && (
            <DNDUploader
              open={openDNDModel}
              close={(e) => {
                setDNDModel(false);
                if (e) getAllLeads();
              }}
            />
          )} */}
        </>
      }
    >
      {openform && (
        <CreateLeads
          existingRequest={selectedLead}
          open={openform}
          onClose={() => {
            setOpenForms(false);
            setSelectedLead(null);
            getAllLeads();
          }}
        />
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "5px",
        }}
      >
        <div>
          <div>
            <DurationFilters
              handleFilterChanged={(e) => {
                // console.log(e)
                // setloading(true)
                setFilters((prev) => ({
                  ...prev,
                  fromDate: e.fromDate,
                  toDate: e.toDate,
                  interval: e.interval,
                  currentPage: 1,
                }));
              }}
              interval={filter.interval}
              isAdmin={true}
              options={durationOptions}
            />
          </div>
          <div
            style={{ marginLeft: "10px", marginTop: "4px" }}
            className="date_section"
          >
            <span>{formattedDate}</span>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          {/* <div
            style={{ display: "flex", flexDirection: "row" }}
            className="input_field"
          >
            <div style={{ display: "flex" }}>
              <div className="inline-flex rounded-full border border-gray-300 w-full">
                <button
                  type="button"
                  className={`px-4 py-2 text-sm rounded-full transition-colors w-1/2 ${
                    filter.is_dnd === null
                      ? "bg-blue-100 text-blue-800 border border-[#0F5EFF]"
                      : "bg-transparent text-gray-700 hover:bg-gray-100"
                  }`}
                  onClick={() => {
                    setFilters((prev) => ({
                      ...prev,
                      is_dnd: null,
                      currentPage: 1,
                    }));
                  }}
                  //   onClick={() => handleTabSwitch("lead")}
                >
                  ALL
                </button>
                <button
                  type="button"
                  className={`px-4 py-2 text-sm rounded-full transition-colors w-1/2 ${
                    filter.is_dnd === true
                      ? "bg-blue-100 text-blue-800 border border-[#0F5EFF]"
                      : "bg-transparent text-gray-700 hover:bg-gray-100"
                  }`}
                  onClick={() => {
                    setFilters((prev) => ({
                      ...prev,
                      is_dnd: prev.is_dnd === true ? null : true, //  toggle
                      currentPage: 1,
                    }));
                  }}
                >
                  DND
                </button>
                <button
                  style={{ whiteSpace: "nowrap", width: "100%" }}
                  type="button"
                  className={`px-4 py-2 text-sm rounded-full transition-colors w-1/2 ${
                    filter.is_dnd === false
                      ? "bg-blue-100 text-blue-800 border border-[#0F5EFF]"
                      : "bg-transparent text-gray-700 hover:bg-gray-100"
                  }`}
                  onClick={() => {
                    setFilters((prev) => ({
                      ...prev,
                      is_dnd: prev.is_dnd === false ? null : false, //  toggle
                      currentPage: 1,
                    }));
                  }}
                >
                  Exclude DND
                </button>
              </div>
            </div>
          </div> */}
          <div
            style={{ display: "flex", flexDirection: "row" }}
            className="input_field"
          >
            <div style={{ display: "flex" }}>
              <div className="inline-flex rounded-full border border-gray-300 w-full">
                <button
                  disabled={leadTabDisabled}
                  type="button"
                  className={`px-4 py-2 text-sm rounded-full transition-colors w-1/2 ${
                    filter.type === "lead"
                      ? "bg-blue-100 text-blue-800 border border-[#0F5EFF]"
                      : "bg-transparent text-gray-700 hover:bg-gray-100"
                  }`}
                  onClick={() => handleTabSwitch("lead")}
                >
                  Lead
                </button>
                <button
                  style={{ whiteSpace: "nowrap", width: "100%" }}
                  disabled={retainTabDisabled}
                  type="button"
                  className={`px-4 py-2 text-sm rounded-full transition-colors w-1/2 ${
                    filter.type === "To Retain"
                      ? "bg-blue-100 text-blue-800 border border-[#0F5EFF]"
                      : "bg-transparent text-gray-700 hover:bg-gray-100"
                  }`}
                  onClick={() => handleTabSwitch("To Retain")}
                >
                  To Retained
                </button>
              </div>
            </div>
          </div>

          <Button
            innerClassName={"filter-btn-inner"}
            iconStyle={{ width: "18px", marginRight: "10px" }}
            text={"Filter"}
            icon={Filter}
            className={"filter-btn"}
            onClick={() => {
              setOpenLeadFilter(true);
            }}
          />
        </div>
      </div>

      {openLeadFilter && (
        <LeadsFilter
          filter={filter}
          open={openLeadFilter}
          onClose={() => {
            console.log("Close");
            setOpenLeadFilter(false);
          }}
          onFilterChange={(data) => {
            setFilters((prev) => ({
              ...prev,
              state: data.state,
              district: data.district,
              taluka: data.taluka,
            }));
          }}
        />
      )}

      {openFilter && (
        <IssueDashboardFilter
          open={openFilter}
          onFilterChange={(e) => {
            console.log(e);

            setFilters((prev) => ({
              ...prev,
              fromDate: e.fromDate,
              toDate: e.toDate,
              interval:
                !e.fromDate || !e.toDate
                  ? e.interval || filter.interval
                  : "custom",
              currentPage: 1,
            }));
            setOpenFilter(false);
          }}
          filter={filter}
          onClose={(e) => {
            console.log(e);
            if (!filter.fromDate || !filter.toDate) {
              console.log("ALL");
              setFilters((prev) => ({ ...prev, interval: "all" }));
              setFormattedDate("");
            }

            setOpenFilter(false);
          }}
        />
      )}

      <TableView
        showSrNo={true}
        onStateChange={async (changedState) => {
          const { pageNumber } = changedState;
          // console.log(changedState);
          setFilters({ ...filter, currentPage: pageNumber });
        }}
        onClickRow={(row) => {
          navigate("/crm/leads/detail", { state: row });
        }}
        isLoading={loading}
        loaderHeight={"500px"}
        columns={[
          { Header: "Name", accessor: "name", width: "15%" },
          // { Header: "Phone", accessor: "phone", width: "10%" },
          { Header: "Source", accessor: "source", width: "15%" },
          { Header: "Email", accessor: "email", width: "25%" },
          {
            Header: "Last Contacted",
            accessor: "last_contacted",
            isDate: true,
            width: "15%",
          },
          // {
          //   Header: "DND",
          //   accessor: "is_dnd",
          //   width: "15%",
          //   Cell: ({ row }) =>
          //     row?.original?.is_dnd ? (
          //       <span
          //         style={{
          //           color: "white",
          //           background: "red",
          //           padding: "2px 8px",
          //           borderRadius: "12px",
          //           fontSize: "12px",
          //           fontWeight: "600",
          //         }}
          //       >
          //         DND
          //       </span>
          //     ) : (
          //       <span>-</span>
          //     ),
          // },
          {
            Header: "Created",
            accessor: "created",
            isDate: true,
            width: "15%",
          },
        ]}
        data={allLeads}
        pageNumber={filter.currentPage ?? 1}
        pageSize={15}
        count={Number(filter?.count) || 0}
        activities={{
          onClickEdit: (lead) => {
            console.log(lead);
            setSelectedLead(lead);
            setOpenForms(true);
          },
          isEdit: true,
        }}
      />
    </MainContentWrapper>
  );
};
